import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import clsx from "clsx";
import {
  IStatisticsRowFields,
  SpecificLocaleFields,
} from "~/@types/generated/contentful";
import { getComponentFromContentfulRichTextEntry } from "~/contentful";
import {
  InsightComponentData,
  useComponentData,
} from "~/contexts/ComponentDataProvider";

type StatisticsRowProps = {
  fields: SpecificLocaleFields<IStatisticsRowFields>;
};

export default function StatisticsRow({ fields }: StatisticsRowProps) {
  const length = fields.blocks.length;
  const { insight } = useComponentData() as InsightComponentData;

  return (
    <section
      data-content-type="statisticsRow"
      data-module-title={fields.moduleTitle}
      className={clsx("col-span-full w-full lg:col-span-8 lg:col-start-3", {
        "text-white": ["black"].includes(fields.backgroundColor),
        "text-black": ["white", "slate"].includes(fields.backgroundColor),
        "bg-black": fields.backgroundColor === "black",
        "bg-white": fields.backgroundColor === "white",
        "bg-slate": fields.backgroundColor === "slate",
        "lg:px-0": insight,
      })}
    >
      <div
        className={clsx(
          "global-container grid py-12 lg:grid-cols-2 lg:gap-y-20 lg:gap-x-6 lg:py-16",
          {
            "lg:grid-cols-3": length === 3,
          },
        )}
      >
        {fields.blocks.map((block, i) => (
          <div
            key={i}
            className={clsx(
              "mb-16 text-center first:col-start-1 last:mb-0 lg:mb-0",
            )}
          >
            <p className="display whitespace-nowrap">{block.fields.heading}</p>

            <div className="body m-auto mt-1 w-9/12 max-w-xs lg:[&>:first-child]:mt-0">
              {block.fields.body &&
                documentToReactComponents(
                  block.fields.body,
                  getComponentFromContentfulRichTextEntry,
                )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
